( function () {
	const facilityMoreContent = document.querySelector( '.facility-details__more-content-wrap' );
	if( !facilityMoreContent ) { return; }

	const btn = facilityMoreContent.querySelector( '.facility-details__more-content-btn' );
	btn.addEventListener( 'click', function() {
		facilityMoreContent.classList.toggle( 'facility-details__more-content-wrap--more' );
	} );
} )();